enum AccessTier {
    Public = 0,
    Viewer = 1,
    Mod = 2,
    Broadcaster = 3,
    Developer = 4,
    Banned = 5
}

export default AccessTier